export default class AddOn {
  /********* CONFIG EXPLAIN ********/

  /*
  ----TYPE_DISCOUNTED_REMOTE_VID----
    remoteVidFee: custom remote vid fee

  ----TYPE_DISCOUNTED_DL_CHECK----
    instoreVidFee: custom instore vid fee, applied if this addon is used

  ----TYPE_INCLUDED_DL_CHECK----
    includedTransactions: number of orders per dealerStore that can have orders with instoreVidFee 0

  ----TYPE_INCLUDED_REMOTE_VID----
    includedTransactions: number of orders per dealerStore that can have orders with remoteVidFee 0

  ----TYPE_SECURE_OFFSITE_CLOSING----
    secureOffsiteClosingFee: custom secureOffsiteClosingFee fee,
    previewDocumentsFee: custom documents preview fee,
    inkSignFee: custom inkSign fee,
    fedexGenerateLabelProcessingFee: custom fedex generate label processing fee,
    r1Fee: r1 order fee,

  ----TYPE_INCLUDED_SECURE_OFFSITE_CLOSING----
    includedTransactions: number of orders per dealerStore that can have orders with all the fees from SECURE_OFFSITE_CLOSING addon 0

  ----TYPE_DISCOUNTED_ESIGN----
  eSignFee: custom eSign fee, applied if this addon is used

  ----TYPE_INCLUDED_ESIGN----
    includedTransactions: number of orders per dealerStore that can have orders with eSignFee 0

   ----TYPE_FLEET----
    vehicleThreshold: number of vehicles that will trigger the application of the custom additional vehicle fee provided by the addon
    additionalVehicleFee: custom additional vehicle fee applied for each vehicle after the order number of vehicles reaches the vehicleThreshold

  ----TYPE_MAV_PRIME----
    mavPrimeFee: custom mav prime fee,
    rushFee: custom rush fee,
    remoteVidFee: custom remote vid fee,
    insuranceVerificationFee: custom insurance verification fee,
    previewDocumentsFee: custom documents preview fee,
    sameDayCompletionFee: custom same day completion fee,

  ----TYPE_INSTORE_INSURANCE_VERIFICATION----
    insuranceVerificationFee: custom insurance verification fee,
  */

  static TYPE_DISCOUNTED_REMOTE_VID = 1;
  static TYPE_DISCOUNTED_DL_CHECK = 2;
  static TYPE_INCLUDED_DL_CHECK = 3;
  static TYPE_INCLUDED_REMOTE_VID = 4;
  static TYPE_ENABLE_GUARANTEE = 5;
  static TYPE_SECURE_OFFSITE_CLOSING = 6;
  static TYPE_INCLUDED_SECURE_OFFSITE_CLOSING = 7;
  static TYPE_DISCOUNTED_ESIGN = 8;
  static TYPE_INCLUDED_ESIGN = 9;
  static TYPE_FLEET = 10;
  static TYPE_MAV_PRIME = 11;
  static TYPE_INSTORE_INSURANCE_VERIFICATION = 12;

  static getAddonTypeNameMap() {
    return {
      [this.TYPE_DISCOUNTED_REMOTE_VID]: 'Discounted Remote VID',
      [this.TYPE_DISCOUNTED_DL_CHECK]: 'Discounted Instore VID',
      [this.TYPE_INCLUDED_DL_CHECK]: 'Included Instore VID',
      [this.TYPE_INCLUDED_REMOTE_VID]: 'Included Remote VID',
      [this.TYPE_ENABLE_GUARANTEE]: 'Guarantee',
      [this.TYPE_SECURE_OFFSITE_CLOSING]: 'Secure Offsite Closing',
      [this.TYPE_INCLUDED_SECURE_OFFSITE_CLOSING]: 'Secure Offsite Closing Included',
      [this.TYPE_DISCOUNTED_ESIGN]: 'Discounted ESign',
      [this.TYPE_INCLUDED_ESIGN]: 'Included ESign',
      [this.TYPE_FLEET]: 'Fleet',
      [this.TYPE_MAV_PRIME]: 'Mav Prime',
      [this.TYPE_INSTORE_INSURANCE_VERIFICATION]: 'Instore Insurance Verification',
    };
  }

  static getAddonTypeName(id) {
    return this.getAddonTypeNameMap()[id];
  }
}